import gql from 'graphql-tag'

export const getCandidateAgencies = gql`
  query($paging: PagingQuery, $filter: AgenciesFilter!) {
    getAgencies(
      filter: $filter,
      paging: $paging
    ) {
      agencies {
        id
        name
        phone
        extensionNumber
        countryCode
        countryCallingCode
        fax
        mailingStreet
        mailingCity
        mailingState
        mailingZipCode
        mailingCountry
      }
    }
  }
`

export const getAgencies = gql`
  query($filter: AgenciesFilter!, $paging: PagingQuery, $order: AgenciesOrder) {
    getAgencies(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      agencies {
        id
        name
        phone
        extensionNumber
        countryCode
        countryCallingCode
        fax
        mailingStreet
        mailingCity
        mailingState
        mailingZipCode
        mailingCountry
        createdAt
        updatedAt
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getAgency = gql`
  query($agencyId: Int!) {
    getAgency(
      agencyId: $agencyId
    ) {
      id
      name
      phone
      extensionNumber
      countryCode
      countryCallingCode
      fax
      mailingStreet
      mailingCity
      mailingState
      mailingZipCode
      mailingCountry
      createdAt
      updatedAt
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`

export const newAgency = gql`
  mutation($agencyInput: AgencyInput!) {
    newAgency(
      agencyInput: $agencyInput
    ) {
      id
    }
  }
`

export const editAgency = gql`
  mutation($agencyInput: AgencyInput!, $agencyId: Int!) {
    editAgency(
      agencyId: $agencyId,
      agencyInput: $agencyInput
    ) {
      id
    }
  }
`

export const deleteAgency = gql`
  mutation($agencyId: Int!) {
    deleteAgency(
      agencyId: $agencyId
    )
  }
`
